import * as React from 'react';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import { AlertTitle, Snackbar } from '@mui/material';
import { CheckCircleOutline, ErrorOutlineOutlined, InfoOutline, WarningAmberOutlined } from '@mui/icons-material';

export default function AlertMessageDialog({message,title,severity,color,open,setOpen,handleClose}) {

  const iconMapping = {
    info: <InfoOutline fontSize="inherit" color="white" />,
    warning: <WarningAmberOutlined fontSize="inherit" color="white" />,
    error: <ErrorOutlineOutlined fontSize="inherit" color="white" />,
    success: <CheckCircleOutline fontSize="inherit" color="white" sx={{color:"white"}}/>,
  };

  const colorMapping = {
    info: "blue",
    warning: "orange",
    error: "red",
    success: "green",
  };
  
  const {vertical,horizontal} = {vertical:'top', horizontal:'center'}
  return (
    <Snackbar
    anchorOrigin={{vertical,horizontal}}
     icon={iconMapping[severity]}
     message={message}
     open={open}
     onClose={()=>{handleClose()}}
     autoHideDuration={4000}>
        <Alert
        onClose={()=>{handleClose()}}
        severity={severity}
        action={
          <IconButton
            aria-label="close"
            size="small"
            onClick={() => handleClose()}
            sx={{ color: "white" }}   
          >
            <CloseIcon fontSize="inherit" sx={{color:"white"}} />
          </IconButton>
        }
        color={colorMapping[severity]}
        sx={{
            backgroundColor: colorMapping[severity],
            color: "white",
            "& .MuiAlert-icon": {
              color: "white", 
            },
        }}
        variant='filled'>
            {title && (
                <AlertTitle fontWeight={"bold"} textAlign={"left"} sx={{color:"white",fontWeight:"bold"}}>{title}</AlertTitle>
            )}
            {message}
        </Alert>

     </Snackbar>
  );
}
